import React from 'react';
import { FadeIn } from './Shared';
import { Gift } from 'lucide-react';
export const BonusesTable = () => {
  const bonuses = [{
    num: '01',
    name: 'Guía de Emergencia: Ya Se Quejaron del Perro',
    desc: 'Qué decir, qué no decir y cómo frenar el conflicto con vecinos, portero o administración sin empeorarlo. Scripts exactos por WhatsApp para cada escenario. Nota formal lista para mandar a la administración. Protocolo de 3 días para crisis activa.',
    value: '$8.990'
  }, {
    num: '02',
    name: 'Kit Compras Inteligentes Anti-Ansiedad',
    desc: 'Qué comprar primero, en qué orden y con qué presupuesto real en Argentina. Setup mínimo viable con lo que ya tenés en casa. Tabla de costo vs impacto real. Qué juguetes decepcionar y cuáles sí valen la pena. Dónde conviene comprar cada cosa.',
    value: '$6.990'
  }, {
    num: '03',
    name: 'Planner Express de Salidas y Rutinas',
    desc: 'La herramienta visual para aplicar el sistema sin improvisar, olvidar pasos ni vivir corriendo. Plantilla de rutina de mañana, planner semanal imprimible, versión para horarios rotativos, semáforo de adherencia y mini tracker de consistencia.',
    value: '$7.990'
  }, {
    num: '04',
    name: 'Protocolo Cámara Sin Obsesión',
    desc: 'Cómo monitorear a tu perro sin arruinar el proceso y sin reforzar tu propia ansiedad. Qué mirar exactamente y cuándo. Qué conductas parecen graves pero son normales. Cuándo volver y cuándo no volver nunca. Las 7 reglas personales para no volverse dependiente del monitoreo.',
    value: '$6.990'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-16">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,165,0,0.05),transparent_70%)] pointer-events-none" data-id="element-17"></div>
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-18">
        <FadeIn data-id="element-19">
          <div className="text-center mb-16" data-id="element-20">
            <div className="inline-block bg-orange-500/10 text-orange-400 px-6 py-2 rounded-full text-xs font-bold tracking-[0.3em] mb-6 border border-orange-500/20 uppercase" data-id="element-21">
              REGALOS EXCLUSIVOS
            </div>
            <h2 className="text-3xl md:text-5xl flex items-center justify-center text-white tracking-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-22">
              <Gift className="w-10 h-10 text-orange-400 mr-6 shrink-0" data-id="element-23" />
              🎁 4 BONOS ESTRATÉGICOS
            </h2>
          </div>

          <div className="space-y-6 mb-12" data-id="element-24">
            {bonuses.map((bono, index) => <div key={index} className="bg-navy-900/40 rounded-3xl border border-white/10 p-6 md:p-10 flex flex-col gap-6 relative overflow-hidden" data-id="element-25">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-8" data-id="element-26">
                  <div className="flex items-start gap-6" data-id="element-27">
                    <span className="text-3xl md:text-5xl font-bold font-sans leading-none text-orange-400" data-id="element-28">
                      {bono.num}
                    </span>
                    <div data-id="element-29">
                      <h3 className="text-xl md:text-2xl font-sans font-bold text-white leading-tight mb-3" data-id="element-30">
                        {bono.name}
                      </h3>
                      <p className="text-gray-300 text-sm md:text-base leading-relaxed font-sans opacity-90" data-id="element-31">
                        {bono.desc}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between sm:justify-end gap-6 sm:shrink-0" data-id="element-32">
                    <div className="flex items-center gap-4" data-id="element-33">
                      <span className="text-gray-500 line-through text-sm md:text-lg font-bold" data-id="element-34">
                        {bono.value}
                      </span>
                      <span className="text-green-400 font-bold bg-green-400/10 px-6 py-2 rounded-full text-xs md:text-sm border border-green-400/30 tracking-widest uppercase" data-id="element-35">
                        GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="bg-gradient-to-br from-navy-800 via-navy-900 to-navy-950 rounded-3xl border-2 border-orange-500/30 p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8 relative overflow-hidden" data-id="element-36">
            <div className="absolute top-0 right-0 -mt-12 -mr-12 w-48 h-48 bg-orange-500/10 rounded-full blur-3xl" data-id="element-37" />
            <div className="text-center md:text-left relative z-10" data-id="element-38">
              <p className="text-orange-400 uppercase tracking-[0.3em] text-[10px] md:text-xs font-bold mb-3 opacity-80" data-id="element-39">
                VALOR TOTAL DE LOS BONOS
              </p>
              <h4 className="text-2xl md:text-4xl font-bold text-white leading-tight font-[Montserrat,_sans-serif]" data-id="element-40">
                Todo esto es tuyo <br className="hidden md:block" data-id="element-41" />
                <span className="text-orange-400" data-id="element-42">sin costo extra</span>
              </h4>
            </div>
            <div className="text-center md:text-right relative z-10" data-id="element-43">
              <span className="text-white/40 line-through text-xl md:text-2xl font-bold block mb-2" data-id="element-44">
                $30.960
              </span>
              <span className="text-green-400 text-5xl md:text-7xl tracking-tighter font-[900] font-[Montserrat,_sans-serif]" data-id="element-45">
                GRATIS
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};